"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldRenderActionContainers = exports.getShouldRenderTitleBelow = void 0;

var _types = require("./types");

var getShouldRenderTitleBelow = function getShouldRenderTitleBelow(_ref) {
  var shouldRenderTitleOnNewLine = _ref.shouldRenderTitleOnNewLine,
      navigationAlignment = _ref.navigationAlignment,
      hasSmallTitle = _ref.hasSmallTitle;

  if (shouldRenderTitleOnNewLine !== undefined) {
    return !!shouldRenderTitleOnNewLine;
  }

  if (navigationAlignment === _types.NavigationAlignments.Trailing) {
    return false;
  }

  return !hasSmallTitle;
};

exports.getShouldRenderTitleBelow = getShouldRenderTitleBelow;

var getShouldRenderActionContainers = function getShouldRenderActionContainers(_ref2) {
  var hasBackButton = _ref2.hasBackButton,
      hasNavigationItem = _ref2.hasNavigationItem,
      navigationAlignment = _ref2.navigationAlignment,
      actions = _ref2.actions;
  var renderLeadingActionContainer = false;
  var renderTrailingActionContainer = false;

  if (navigationAlignment === _types.NavigationAlignments.Leading) {
    renderLeadingActionContainer = hasNavigationItem;
  } else {
    renderTrailingActionContainer = hasNavigationItem;
  }

  if (hasBackButton) {
    renderLeadingActionContainer = true;
    renderTrailingActionContainer = hasNavigationItem;
  }

  if (actions && actions.length > 0) {
    renderTrailingActionContainer = true;
  }

  return {
    renderLeadingActionContainer: renderLeadingActionContainer,
    renderTrailingActionContainer: renderTrailingActionContainer
  };
};

exports.getShouldRenderActionContainers = getShouldRenderActionContainers;